import { User } from "@sendbird/chat/lib/__definition";
import axios from "axios";

import { endpoints } from "../../../api/endpoints";

export interface MessagingPlatformAdmin {
  id: number;
  name: string;
  last_name?: string;
  isAdmin?: boolean;
}

interface SearchPlatformUser {
  id: number;
  name: string;
  last_name?: string;
}

type PlatformUsersSearchResponse = {
  total: number;
  users: SearchPlatformUser[];
};

export function platformUserToSendbirdUser(user: SearchPlatformUser): User {
  const nickname =
    [user.name, user.last_name].filter(Boolean).join(" ").trim() || user.name;
  return { userId: String(user.id), nickname } as User;
}

export async function searchPlatformUsers(
  query: string,
  limit = 20
): Promise<User[]> {
  const { data } = await axios.get<PlatformUsersSearchResponse>(
    `${endpoints.searchUsers}?q=${encodeURIComponent(query)}&limit=${limit}`
  );
  return (data.users ?? []).map(platformUserToSendbirdUser);
}

export async function ensureSendbirdUsers(userIds: string[]): Promise<void> {
  if (userIds.length === 0) {
    return;
  }
  await axios.post(endpoints.ensureMessagingSendbird, { userIds });
}

export async function ensureGroupChatManagerAccess(channelUrl: string): Promise<void> {
  if (!channelUrl) {
    return;
  }
  await axios.post(endpoints.ensureGroupChatManagerAccess, { channelUrl });
}

export async function fetchPlatformAdmins(): Promise<MessagingPlatformAdmin[]> {
  const { data } = await axios.get<MessagingPlatformAdmin[]>(endpoints.admin.getUsers);
  return (data ?? []).filter((user) => Boolean(user.isAdmin));
}
